"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Enums_1 = require("../common/Enums");
var AWTTransmissionManager_1 = require("./AWTTransmissionManager");
var Utils = require("../common/Utils");
var Version = require("./Version");
var AllTokens = 'allTkns';
var EventNameAndTypeRegex = /^[a-zA-Z0-9]([a-zA-Z0-9]|_){2,98}[a-zA-Z0-9]$/;
var EventNameDotRegex = /\./g;
var PropertyNameRegex = /^[a-zA-Z0-9](([a-zA-Z0-9|_|\.]){0,98}[a-zA-Z0-9])?$/;
var AWT = /** @class */ (function () {
    function AWT() {
    }
    AWT.initialize = function (tenantToken, configuration) {
        if (configuration === void 0) { configuration = {}; }
        if (this._isInitialized) {
            // tslint:disable-next-line
            throw 'Already Initialized';
        }
        this._defaultTenantToken = tenantToken;
        this._overrideValuesFromConfig(configuration);
        //Create sender
        AWTTransmissionManager_1.default.initialize(this._config);
        this._isInitialized = true;
    };
    AWT.flush = function (callback) {
        if (this._isInitialized && !this._isDestroyed) {
            AWTTransmissionManager_1.default.flush(callback);
        }
    };
    AWT.flushAndTeardown = function () {
        if (this._isInitialized && !this._isDestroyed) {
            this._isDestroyed = true;
            AWTTransmissionManager_1.default.flushAndTeardown();
        }
    };
    AWT.setContext = function (name, property, tenantToken) {
        if (tenantToken === void 0) { tenantToken = AllTokens; }
        property = this._sanitizeProperty(name, property);
        if (property === null) {
            return;
        }
        if (!this._contextProperties[tenantToken]) {
            this._contextProperties[tenantToken] = {};
        }
        this._contextProperties[tenantToken][name] = property;
    };
    AWT.logEvent = function (event) {
        var _this = this;
        if (this._isInitialized) {
            if (!event.name || !event.properties) {
                return;
            }
            event.name = event.name.toLowerCase();
            event.name.replace(EventNameDotRegex, '_');
            var typePrefix = '';
            if (!event.type) {
                event.type = 'custom';
            }
            else {
                event.type.toLowerCase();
                typePrefix = 'custom.';
            }
            if (!EventNameAndTypeRegex.test(event.name) || !EventNameAndTypeRegex.test(event.type)) {
                return;
            }
            event.type = typePrefix + event.type;
            if (isNaN(event.timestamp)) {
                event.timestamp = (new Date()).getTime();
            }
            if (!event.tenantToken) {
                event.tenantToken = this._defaultTenantToken;
            }
            event.id = Utils.newGuid();
            Object.keys(event.properties).forEach(function (name) {
                event.properties[name] = _this._sanitizeProperty(name, event.properties[name]);
                if (event.properties[name] === null) {
                    delete event.properties[name];
                }
            });
            this._addContextIfAbsent(event, event.tenantToken);
            this._addContextIfAbsent(event, AllTokens);
            if (Object.keys(event.properties).length === 0) {
                return;
            }
            this._setDefaultProperty(event, 'EventInfo.InitId', this._getInitId(event.tenantToken));
            this._setDefaultProperty(event, 'EventInfo.Sequence', this._getSequenceId(event.tenantToken));
            this._setDefaultProperty(event, 'EventInfo.SdkVersion', Version.FullVersionString);
            this._setDefaultProperty(event, 'EventInfo.Name', event.name);
            this._setDefaultProperty(event, 'EventInfo.Time', (new Date(event.timestamp)).toISOString());
            AWTTransmissionManager_1.default.sendEvent(event);
        }
    };
    AWT._overrideValuesFromConfig = function (config) {
        if (config.collectorUrl) {
            this._config.collectorUrl = config.collectorUrl;
        }
        if (config.sendingTimer > 1000) {
            this._config.sendingTimer = config.sendingTimer;
        }
    };
    AWT._getInitId = function (tenantToken) {
        if (this._initIdMap[tenantToken] === undefined) {
            this._initIdMap[tenantToken] = Utils.newGuid();
        }
        return this._initIdMap[tenantToken];
    };
    AWT._getSequenceId = function (tenantToken) {
        if (this._sequenceIdMap[tenantToken] === undefined) {
            this._sequenceIdMap[tenantToken] = 0;
        }
        return (++this._sequenceIdMap[tenantToken]).toString();
    };
    AWT._setDefaultProperty = function (event, name, value) {
        event.properties[name] = { value: value, pii: Enums_1.AWTPiiKind.NotSet };
    };
    AWT._addContextIfAbsent = function (event, tenantToken) {
        if (this._contextProperties[tenantToken]) {
            var context_1 = this._contextProperties[tenantToken];
            Object.keys(context_1).forEach(function (name) {
                if (!event.properties[name]) {
                    event.properties[name] = context_1[name];
                }
            });
        }
    };
    AWT._sanitizeProperty = function (name, property) {
        if (typeof property === 'string' || typeof property === 'number' || typeof property === 'boolean') {
            property = { value: property };
        }
        if (!PropertyNameRegex.test(name) || property === undefined || property === null
            || property.value === null || property.value === undefined || property.value === '') {
            return null;
        }
        if (typeof property.pii === 'undefined') {
            property.pii = Enums_1.AWTPiiKind.NotSet;
        }
        property.value = property.value.toString();
        return Utils.isPii(property.pii) ? property : null;
    };
    AWT._isInitialized = false;
    AWT._isDestroyed = false;
    AWT._contextProperties = {};
    AWT._sequenceIdMap = {};
    AWT._initIdMap = {};
    AWT._config = {
        collectorUrl: 'https://browser.pipe.aria.microsoft.com/Collector/3.0/',
        sendingTimer: 1000
    };
    return AWT;
}());
exports.default = AWT;
